module.exports = __webpack_public_path__ + "img/gift.ddad1af3.jpg";